import { Alert, Button, Flex, Heading, IconAddLine } from "@instructure/ui";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { sort } from "../../utils/utils";
import ReflectionTemplateCard from "./ReflectionTemplateCard";

const ViewReflectionTemplates = ({ templates, setTemplates, cycleTypes }) => {
  return (
    <>
      <div style={{ marginBottom: "15px", borderBottom: "1px solid #ccc" }}>
        <Flex justifyItems="space-between" alignItems="end">
          <Flex.Item shouldGrow>
            <Heading as="h2" level="h3">
              {t("reflectionTemplates.reflectionTemplates")}
            </Heading>
          </Flex.Item>
          <Flex.Item>
            <Link
              to={{
                pathname: "/setup/reflection-templates/",
                search: "?mode=create",
              }}
            >
              <Button
                id="create-template-button"
                color="primary"
                renderIcon={IconAddLine}
              >
                {t("templates.createTemplate")}
              </Button>
            </Link>
          </Flex.Item>
        </Flex>
      </div>

      {templates ? (
        templates.length > 0 ? (
          <Flex wrap="wrap" alignItems="start" gap="small">
            {sort(templates, (t) => t.name).map((template, key) => (
              <Flex.Item size="100%" key={key}>
                <ReflectionTemplateCard
                  template={template}
                  setTemplates={setTemplates}
                  cycleTypes={cycleTypes}
                />
              </Flex.Item>
            ))}
          </Flex>
        ) : (
          <Alert>{t("templates.noTemplatesAlert")}</Alert>
        )
      ) : (
        <Skeleton
          count={3}
          style={{ height: 106, borderRadius: 5, marginBottom: 10 }}
        />
      )}
    </>
  );
};

export default ViewReflectionTemplates;
